module.exports = __webpack_public_path__ + "img/Project.55f1ccb3.png";